import { type ReactNode } from 'react';

import styles from './richComponents.module.scss';

export const richComponents = {
  accent: (chunks: ReactNode) => <span className={styles.accent}>{chunks}</span>,
} as const;
